import { useAuthenticator } from "@aws-amplify/ui-react";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { Center, createStyles, Stack } from "@mantine/core";
import { RpiBodyText, RpiLabelText, RpiTitle, useShowSuccessToast } from "@rpi/openapi-core";
import { RpaButtonLink } from "../../../components/RpiLink";

const useConfirmSignUpStyles = createStyles((theme) => ({
  authHeader: {
    alignItems: "center",
    gap: theme.spacing.lg,
  },
  paragraph: {
    alignItems: "center",
    alignContent: "center",
    gap: 0,
  },
}));

export const confirmSignUpComponent: DefaultComponents["ConfirmSignUp"] = {
  Header() {
    const { classes } = useConfirmSignUpStyles();
    return (
      <Stack className={classes.authHeader}>
        <RpiTitle>We sent you an email.</RpiTitle>
        <Stack className={classes.paragraph}>
          <RpiLabelText>Please check your inbox for a confirmation code and enter it below.</RpiLabelText>
          <RpiBodyText>If you don't see it in a couple of minutes, check your spam folder.</RpiBodyText>
        </Stack>
      </Stack>
    );
  },
  Footer() {
    const { resendCode } = useAuthenticator();
    const showSuccessToast = useShowSuccessToast();
    function handleResendCode() {
      resendCode();
      showSuccessToast("A new confirmation code has been sent to your email!");
    }

    return (
      <Center>
        <RpaButtonLink onClick={() => handleResendCode()}>Resend Code</RpaButtonLink>
      </Center>
    );
  },
};
